










































































































































































/* eslint-disable */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { ValidationObserver } from 'vee-validate';

import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import FilterIcon from 'mdi-vue/Filter';
import DownloadIcon from 'mdi-vue/Download';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import FormInput from '@/components/FormInput.vue';

import { Division, Service } from '@/libs/api.interfaces';

import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import InvoiceTable from './InvoiceTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    FilterIcon,
    DownloadIcon,
    SearchRow,
    SearchField,
    Select,
    InvoiceTable,
    ModalDialog,
    FormInput,
    ValidationObserver,
  },
})
export default class Invoice extends Vue {
  searchOpen = false;
  dialogGenerate = false;
  month: LabelValue | null = null;
  year: LabelValue | null = null;
  status: LabelValue | null = null;

  $refs!: {
    table: InvoiceTable;
  }

  selectedMerchant: { merchant_code: string; merchant_name: string } | null = null;
  loadingMerchant = false;
  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  loadingService = false;
  services: any[] = [];
  selectedService: any | null = null;

  loadingBrand = false;
  brands: any[] = [];
  selectedBrand: any | null = null;

  months = [
    {
      label: 'All',
      value: '0',
    },
    ...[...Array(12)].map((_, i) => ({
      label: dayjs().month(i).format('MMMM'),
      value: (i + 1).toString().padStart(2, '00'),
    })),
  ];

  years = [
    {
      label: 'All',
      value: '0',
    },
    ...[...Array(15)].map((_, i) => {
      const now = dayjs().subtract(i, 'year').format('YYYY');
      return {
        label: now,
        value: now,
      };
    }),
  ]

  statuses = [
    {
      label: 'All',
      value: '0',
    }, {
      label: 'Pending',
      value: '2',
    }, {
      label: 'Generated',
      value: '3',
    },
  ]

  loadingGenerate = false;
  loadingExport = false;

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  async mounted() {
    this.getMerchants();
    this.status = this.statuses[1];
    this.parseParams();
    this.getService(this.selectedMerchant?.merchant_code);
    this.getBrand(this.selectedMerchant?.merchant_code);
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getMerchants() {
    try {
      this.loadingMerchant = true;
      const { data } = await api.get('/recon/merchant');
      /* eslint-disable @typescript-eslint/camelcase */
      this.merchants = [{
        merchant_code: '',
        merchant_name: 'All',
      }, ...data.data];
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getService(merchant_code: string = "") {
    try {
      this.loadingService = true;
      const merchant = merchant_code ? `?merchant_code=${merchant_code}` : ""
      const { data } = await api.get(`/recon/merchant/services${merchant}`);
      /* eslint-disable @typescript-eslint/camelcase */
      this.services = [{
        service: 'All',
        service_name: 'All',
      }, ...data.data];
      /* eslint-enable @typescript-eslint/camelcase */

      this.loadingService = false;
    } catch (err) {
      console.error(err);
    }
  }

  /* eslint-disable @typescript-eslint/camelcase */
  async getBrand(merchant_code: string = "") {
    try {
      this.loadingBrand = true;
      const merchant = merchant_code ? `?merchant_code=${merchant_code}` : ""
      const { data } = await api.get(`/recon/getbrand${merchant}`);
      /* eslint-disable @typescript-eslint/camelcase */
      this.brands = [{
        brand_name: 'All',
      }, ...data.data];
      /* eslint-disable @typescript-eslint/camelcase */

      this.loadingBrand = false;
    } catch (error) {
      console.error(error);
    }
  }

  search() {
    this.$router.push({
      query: {
        mc: this.selectedMerchant === null ? undefined : JSON.stringify(this.selectedMerchant),
        mt: this.month === null ? undefined : this.month.value,
        yr: this.year === null ? undefined : this.year.value,
        st: this.status === null ? undefined : this.status.value,
        sv: this.selectedService === null ? undefined : JSON.stringify(this.selectedService),
        sb: this.selectedBrand === null ? undefined : JSON.stringify(this.selectedBrand),
      },
    });
  }

  reset() {
    this.month = null;
    this.year = null;
    this.status = {
      label: 'Pending',
      value: '2',
    };
    this.selectedMerchant = null;
    this.selectedService = null;
    this.selectedBrand = null;

    this.$router.push({
      query: {},
    });
  }

  async getInvoice(page: number, isExport: boolean = false) {
    const params = {
      year: this.year,
      month: this.month,
      merchant: this.selectedMerchant,
      status: this.status,
      service: this.selectedService,
      brand: this.selectedBrand,
    };

    await this.$refs.table.getInvoice(params, page, isExport);
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.yr === 'string') {
      const year = this.years.find((e) => e.value === params.yr);
      if (year) {
        this.year = year;
      }
    } else {
      this.year = null;
    }

    if (typeof params.mt === 'string') {
      const month = this.months.find((e) => e.value === params.mt);
      if (month) {
        this.month = month;
      }
    } else {
      this.month = null;
    }

    if (typeof params.mc === 'string') {
      const merchant = JSON.parse(params.mc);
      this.selectedMerchant = merchant;
    } else {
      this.selectedMerchant = null;
    }

    if (typeof params.st === 'string') {
      const status = this.statuses.find((e) => e.value === params.st);
      if (status) {
        this.status = status;
      } else {
        this.status = null;
      }
    }

    if (typeof params.sv === 'string') {
      const service = JSON.parse(params.sv);
      if (service) {
        this.selectedService = service;
      } else {
        this.selectedService = null;
      }
    }

    if (typeof params.sb === 'string') {
      const brand = JSON.parse(params.sb);
      if (brand) {
        this.selectedBrand = brand;
      } else {
        this.selectedBrand = null;
      }
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getInvoice(page);
  }

  disableGenerateAll() {
    try {
      if (this.$refs.table) {
        const listSelected: string[] = Object.keys(this.$refs.table.selected) || [];
        if (listSelected.length) {
          for (const value of Object.values(this.$refs.table.selected)) {
            if (value.status !== 2) {
              return true;
            }
          }
        } else {
          return true;
        }
        return false;
      }
      return true;
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  generateInvoice() {
    try {
      this.dialogGenerate = false;
      this.loadingGenerate = true
      let finalData: any[] = Object.keys(this.$refs.table.selected);

      api.post('recon/invoice/confirm',
        {
          data: JSON.stringify(finalData),
        }).then((result: any) => {
          if (result.data.status) {
            showToast(ToastType.SUCCESS, 'Generate Invoice Success', 'Change Invoice Status has been successfully processed');
            this.getInvoice(this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1);
            this.$refs.table.selected = {};
            // this.$refs.table.page = 1;
          } else {
            showToast(ToastType.FAILED, 'Generate Invoice Failed', result.data.message);
          }
          this.loadingGenerate = false;
        }).catch((error: any) => {
          console.log(error)
          showToast(ToastType.FAILED, 'Generate Invoice Failed', 'An Error Occured');
          this.loadingGenerate = false;
        })
    } catch (error) {
      console.log(error);
      this.loadingGenerate = false;
    }
  }

  async exportInvoice() {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');
    this.loadingExport = true;
    await this.getInvoice(this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1, true);
    this.loadingExport = false;
  }

  periodeChanged(trigger: string) {
    if (trigger === 'year') {
      if (this.year?.value === '0') {
        this.month = this.months.filter((val) => val.value === '0')[0];
      } else {
        console.log('month', this.month, !this.month);
        if (!this.month || this.month?.value === '0') {
          this.month = this.months.filter((val) => val.value === (dayjs().get('month') + 1).toString().padStart(2, '00'))[0]
        }
      }
    } else {
      if (this.month?.value === '0') {
        this.year = this.years.filter((val) => val.value === '0')[0];
      } else {
        if (!this.year || this.year?.value === '0') {
          this.year = this.years.filter((val) => val.value === dayjs().get('year').toString())[0]
        }
      }
    }
  }

  selectMerchant() {
    this.selectedService = null;
    this.selectedBrand = null;
    this.getService(this.selectedMerchant?.merchant_code);
    this.getBrand(this.selectedMerchant?.merchant_code);
  }
}
